import * as React from "react";
import { Box, Typography } from "@mui/material";

type Props = {
  displayName: string;
  onProfile: () => void;
  onLogout: () => void;
};

export default function DesktopTopbar({ displayName, onProfile, onLogout }: Props) {
  const buttonSx = {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    height: "38px",
    px: "16px",
    bgcolor: "transparent",
    border: "1.5px solid #E2E8F0",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "13px",
    color: "#0D1F3C",
    fontFamily: "Pretendard, sans-serif",
    fontWeight: 500,
    transition: "border-color 0.15s",
    "&:hover": { borderColor: "#0D1F3C" },
  };

  return (
    <Box
      sx={{
        display: { xs: "none", md: "flex" },
        alignItems: "center",
        justifyContent: "space-between",
        height: "64px",
        px: "32px",
        bgcolor: "white",
        borderBottom: "1px solid #E2E8F0",
        position: "sticky",
        top: 0,
        zIndex: 50,
        flexShrink: 0,
      }}
    >
      {/* 왼쪽: 인사말 */}
      <Box>
        <Typography
          sx={{
            fontFamily: '"Playfair Display", serif',
            fontSize: "18px",
            fontStyle: "italic",
            color: "#0D1F3C",
            lineHeight: 1.3,
          }}
        >
          안녕하세요,{" "}
          <Typography
            component="span"
            sx={{
              fontFamily: '"Playfair Display", serif',
              fontSize: "18px",
              fontWeight: 700,
              fontStyle: "italic",
              color: "#0D1F3C",
            }}
          >
            {displayName}
          </Typography>{" "}
          님
        </Typography>
        <Typography sx={{ fontSize: "12px", color: "#8896AB", mt: "2px" }}>
          오늘도 품격 있는 인연을 만나보세요
        </Typography>
      </Box>

      {/* 오른쪽: 액션 버튼 */}
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Box component="button" onClick={onProfile} sx={buttonSx}>
          📋 프로필 수정
        </Box>
        {/* 구분선 */}
        <Box sx={{ width: "1px", height: "24px", bgcolor: "#E2E8F0" }} />
        <Box component="button" onClick={onLogout} sx={buttonSx}>
          🚪 로그아웃
        </Box>
      </Box>
    </Box>
  );
}
